import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
//import { UsuariosFilter } from './usuarios-filter';
import { RenderFilters } from '../../../elements/render-filters';
//import { ConductoresForm } from './conductores-form';
//import { ConductoresFilter } from './conductores-filter';

export const Asignaciones = () => {
    const { open, close } = useDrawer();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);




    const handleNewAction = () => {
        navigate('/assignments/create')
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            secondaryAction={handleNewAction}
            title={'common.label.asignaciones'}
            secondaryActionTitle={'common.label.asignar-devolver-vehiculo'}
        >
            <>

                <Table
                    path="/fleet/assignments/"
                    deletePath="/fleet/assignments/"
                    callBeforeDrawerClosed={handleClose}
                    withPagination
                    onShow={(item: any) => navigate(`/assignments/${item.id}`)}
                    noEdit={true}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'vehicle',
                            subKey: 'plate',
                            label: 'common.label.vehiculo'
                        },
                        {
                            key: 'driver',
                            subKey: 'full_name',
                            label: 'common.label.conductor'
                        },
                        {
                            key: 'assignment_datetime',
                            type: 'datetime',
                            label: 'common.label.fecha-hora-asignacion',
                        },
                        {
                            key: 'completion_datetime',
                            type: 'datetime',
                            label: 'common.label.fecha-hora-finalizacion',
                        },
                    ]}
                />
            </>
        </PageBody>
    );
};